import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { getTranslation } from "../../translations/getTranslations";
import { useSelector } from "react-redux";

const ConfirmModal = ({ showModal, onConfirm, onClose, messageKey, titleKey }) => {
  const language = useSelector(state => state.settings.language);
  const translation = key => getTranslation("confirmModal", key, language);

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="relative w-[400px] rounded bg-backgroundPrimary p-6 text-center text-lg text-textPrimary shadow-lg">
        <button
          className="absolute right-1 top-0 p-2 text-xl text-buttonCancel hover:text-buttonCancelHover"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <h2 className="mb-4 text-2xl font-semibold">{translation(titleKey || "_confirmTitle")}</h2>

        <p className="mb-6 text-base">{translation(messageKey || "_confirmMessage")}</p>

        <div className="flex justify-center gap-4">
          <button
            className="rounded bg-buttonCancel px-6 py-2 text-base text-buttonText hover:bg-buttonCancelHover"
            onClick={onClose}
          >
            {translation("_cancel")}
          </button>
          <button
            className="rounded bg-buttonSubmit px-6 py-2 text-base text-buttonText hover:bg-buttonSubmitHover"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {translation("_confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
